/* ============================================================
   blogStore.js — CropGuard AI
   Pehle yeh file localStorage mein posts save karti thi.
   Ab saara data backend (PHP + MySQL) se aata hai — see
   src/services/api.js. Yeh file ab sirf shared display
   constants aur ek chota client-side fallback slug helper
   rakhti hai (backend hi asal slug generate/store karta hai).
   ============================================================ */

/* ── Tag → gradient map ── */
export const TAG_BG = {
  Tomato:     'linear-gradient(135deg,#1a3a26,#2d6a4f)',
  Maize:      'linear-gradient(135deg,#2a2a14,#4a4a1a)',
  Technology: 'linear-gradient(135deg,#1a2a3a,#2a4a6a)',
  General:    'linear-gradient(135deg,#1a2a1a,#2a3a2a)',
  Research:   'linear-gradient(135deg,#2a1a2a,#4a2a4a)',
  Wheat:      'linear-gradient(135deg,#2a2010,#4a3a1a)',
  Cotton:     'linear-gradient(135deg,#1a1a2a,#2a2a4a)',
};
export const TAG_EMOJIS = {
  Tomato: '🍅', Maize: '🌽', Technology: '🤖', General: '🌿',
  Research: '🔬', Wheat: '🌾', Cotton: '🪴',
};

/* Fallback slug builder — backend generates the real slug on
   create, this is only used if a post object somehow lacks one. */
export function makeSlug(title) {
  return (title || '')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .substring(0, 80);
}

export function postLink(post) {
  return `/blog/${post.slug || makeSlug(post.title)}`;
}
